import { Dispatch } from "react";
import { toast } from "react-toastify";
import * as types from "./type";

// 🧾 Define Product Type
export interface ProductItem {
  id: number | string;
  title: string;
  slug?: string;
  price?: number | string;
  delPrice?: number | string;
  proImg?: string;
  brand?: string;
  stock?: string;
  size?: string;
}

// 🧾 Define Redux Action Type
export interface CartAction {
  type: string;
  product?: ProductItem;
  qty?: number;
  color?: string;
  size?: string;
  product_id?: number | string;
  id?: number | string;
  products?: ProductItem[];
}

// 🟢 Fetch Products
export const fetchProductsBegin = (): CartAction => ({
  type: types.FETCH_PRODUCTS_BEGIN,
});

export const receiveProducts = (products: ProductItem[]): CartAction => ({
  type: types.RECEIVE_PRODUCTS,
  products,
});

// 🛒 Add to Cart
export const addToCart =
  (product: ProductItem, qty = 1, color?: string, size?: string) =>
  (dispatch: Dispatch<CartAction>) => {
    if (product?.title) {
      toast.success(`${product.title} added to cart`, { autoClose: 2000 });
    }

    dispatch({
      type: types.ADD_TO_CART,
      product,
      qty,
      color,
      size,
    });
  };

// ❌ Remove from Cart
export const removeFromCart =
  (product_id: number | string) => (dispatch: Dispatch<CartAction>) => {
    toast.info("Item removed from cart", { autoClose: 2000 });

    dispatch({
      type: types.REMOVE_FROM_CART,
      product_id,
    });
  };

// 🔼 Increment Quantity
export const incrementQuantity =
  (product_id: number | string) => (dispatch: Dispatch<CartAction>) => {
    dispatch({
      type: types.INCREMENT_QUANTITY,
      product_id,
    });
  };

// 🔽 Decrement Quantity
export const decrementQuantity =
  (product_id: number | string) => (dispatch: Dispatch<CartAction>) => {
    dispatch({
      type: types.DECREMENT_QUANTITY,
      product_id,
    });
  };

// 💖 Add / Remove from Wishlist (toggle behavior)
export const addToWishList =
  (product: ProductItem) =>
  (dispatch: Dispatch<CartAction>, getState: any) => {
    const { w_list } = getState().wishList;

    const isInWishlist = w_list.some(
      (item: ProductItem) => item.id === product.id
    );

    if (isInWishlist) {
      toast.error(`${product.title} removed from wishlist`, { autoClose: 2000 });
      dispatch({
        type: types.REMOVE_FROM_WISHLIST,
        id: product.id,
      });
    } else {
      toast.success(`${product.title} added to wishlist`, { autoClose: 2000 });
      dispatch({
        type: types.ADD_TO_WISHLIST,
        product,
      });
    }
  };

// 💔 Explicit Remove from Wishlist (for WishlistPage)
export const removeFromWishList =
  (id: number | string) => (dispatch: Dispatch<CartAction>) => {
    toast.error("Item removed from wishlist", { autoClose: 2000 });
    dispatch({
      type: types.REMOVE_FROM_WISHLIST,
      id,
    });
  };

// ⚖️ Add / Remove Compare List (toggle behavior)
export const addToCompareList =
  (product: ProductItem) =>
  (dispatch: Dispatch<CartAction>, getState: any) => {
    const { compare_list } = getState().compareList;

    const isInCompareList = compare_list.some(
      (item: ProductItem) => item.id === product.id
    );

    if (isInCompareList) {
      toast.info(`${product.title} removed from compare list`, { autoClose: 2000 });
      dispatch({
        type: types.REMOVE_FROM_COMPARE_LIST,
        product,
      });
    } else {
      toast.success(`${product.title} added to compare list`, { autoClose: 2000 });
      dispatch({
        type: types.ADD_TO_COMPARE,
        product,
      });
    }
  };
